// extracted by mini-css-extract-plugin
export default {"topHeading":"cofonderdropdown_topHeading__Xlvg-","actionButton":"cofonderdropdown_actionButton__iyzpN","icon":"cofonderdropdown_icon__-2YqI"};